"use client";

import { useCallback } from "react";
import { useSWRConfig } from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import {
  ICampaignSimpleMessage,
  ICampaignSimpleMessageInput,
} from "@/interfaces/campaign-simple-message.interface";
import campaignSimpleMessageService from "@/services/campaign-simple-message.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type UseCreateCampaignSimpleMessageReturn =
  RequestsBaseReturn<ICampaignSimpleMessage | null> & {
    createCampaignSimpleMessage: (
      data: ICampaignSimpleMessageInput
    ) => Promise<ICampaignSimpleMessage>;
  };

const useCreateCampaignSimpleMessage = (): UseCreateCampaignSimpleMessageReturn => {
  const { mutate } = useSWRConfig();

  const createCampaignSimpleMessage = useCallback(
    async (data: ICampaignSimpleMessageInput): Promise<ICampaignSimpleMessage> => {
      const response = await campaignSimpleMessageService.create(data);
      await mutate(SWR_KEYS.getCampaignSimpleMessages);
      return response;
    },
    [mutate]
  );

  return {
    data: null,
    isLoading: false,
    error: undefined,
    createCampaignSimpleMessage,
  };
};

export default useCreateCampaignSimpleMessage;
